import React from 'react';

export default function Contact() {
  return (
    <section id="contact" className="py-16 px-8 bg-white text-center">
      <h2 className="text-3xl font-bold mb-6">Contact Me</h2>
      <p className="text-lg mb-4">Email: <a href="mailto:david.muendo.musau@gmail.com" className="text-blue-600 underline">david.muendo.musau@gmail.com</a></p>
      <p className="text-lg">Phone: <span className="text-gray-700">+254 758 307 171</span></p>
    </section>
  );
}
